class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 15v-1.003H4.01a1.009 1.009 0 0 1-.817-1.603l2.469-3.397h.003L6.999 7.16V2h2v5.16l.6.826 1.24.003L10 6.837V2h1V1H5v1h1v4.837L2.385 11.81A2.01 2.01 0 0 0 4.01 15H5.5Zm8.014 1h-2V9h2c.532 0 1.04.209 1.415.586.377.374.585.883.585 1.414v3c0 .529-.208 1.037-.585 1.411a1.991 1.991 0 0 1-1.415.589Zm-1-1h1a1.001 1.001 0 0 0 1-1v-3a.999.999 0 0 0-1-1h-1v5Z"></path><path d="M9.514 16h-3v-1h3v-2h-2a1 1 0 0 1-.705-.294A1 1 0 0 1 6.514 12v-2a1.001 1.001 0 0 1 1-1h3v1h-3v2h2a.999.999 0 0 1 1 1v2a.997.997 0 0 1-1 1Z"></path></svg>';
  }
}
const t = "pi-safe-doc";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
